import React from 'react';
import { Helmet } from 'react-helmet';
import OrderDetails from '../components/OrderDetails';

const OrderDetailsPage = () => {
  return (
    <>
      <Helmet>
        <title>Orders</title>
      </Helmet>
      <OrderDetails />
    </>
  );
};

export default OrderDetailsPage;
